<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <div class="d-flex justify-content-between">
          <div><strong>Organizations</strong></div>
        </div>
      </div>
      <b-row v-if="admin.level <= 1">
        <b-col md="12" class="pb-4">
          <router-link class="btn btn-primary" to="create">
            <i class="fa fa-plus"></i>&nbsp;Create New
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="my-1">
          <b-form-group horizontal label="Per page:" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" class="w-25 mb-1" />
          </b-form-group>
        </b-col>
        <b-col md="6" class="my-1">
          <div class="float-right">
            <b-form-group horizontal label="Search:" class="mb-0">
              <b-input-group class="w-75 mb-1">
                <b-form-input v-model="filter" placeholder="Type to Search"  />
              </b-input-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <div class="row">
        <b-col md="12" class="my-1">
          <b-table show-empty
                   striped
                   responsive="sm"
                   :items="organizations"
                   :fields="filteredFields"
                   :current-page="currentPage"
                   :per-page="perPage"
                   :filter="filter"
                   @filtered="onFiltered"
            >
            <template slot="name" slot-scope="data">
              <strong>{{data.item.name}}</strong>
            </template>
            <template slot="edit" slot-scope="data">
              <router-link class="btn btn-success btn-block" :to="'edit/' + data.item.id">
                <i class="fa fa-edit"></i>&nbsp;Edit
              </router-link>
            </template>
            <template slot="delete" slot-scope="data">
              <b-button block variant="danger" @click="confirmDelete('organization', data.item.id)">
                <i class="fa fa-trash"></i>&nbsp;Delete
              </b-button>
            </template>
          </b-table>
          <b-row>
            <b-col md="6" class="my-1">
              Showing {{ showingFrom }} - {{ showingTo }} of {{ totalRows }} organizations
            </b-col>
            <b-col md="6" class="my-1">
              <div class="float-right">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons />
              </div>
            </b-col>
          </b-row>
        </b-col>
      </div>
      <b-row v-if="admin.level <= 1">
        <b-col md="12" class="pb-4">
          <router-link class="btn btn-primary" to="create">
            <i class="fa fa-plus"></i>&nbsp;Create New
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <modal name="confirm-delete-organization" height="auto" :adaptive="true" @before-open="deleteOrganizationOpen" style="z-index: 10000;">
      <div class="container">
        <b-row class="row-top-delete">
          <b-col xs="10" class="my-1">
            <h2>Delete Organization</h2>
          </b-col>
          <b-col xs="2" class="my-1">
            <button type="button" class="close" @click="$modal.hide('confirm-delete-organization')" aria-hidden="true">&times;</button>
          </b-col>
        </b-row>
        <b-row class="row-middle-delete">
          <b-col xs="12" class="my-1">
            <p>Are you sure you want to delete this organization? This process cannot be undone.</p>
          </b-col>
        </b-row>
        <b-row class="row-bottom-delete">
          <b-col xs="12" class="my-1">
            <div class="d-flex float-right modal-buttons">
              <b-button @click="$modal.hide('confirm-delete-organization')">Cancel</b-button>
              <b-button variant="danger" @click="deleteOrganization(); $modal.hide('confirm-delete-organization')">
                Delete
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'
import filteredFields from './../../mixins/filteredFields'
import confirmDelete from './../../mixins/confirmDelete'
import getAdmin from './../../mixins/getAdmin'
import onFiltered from './../../mixins/onFiltered'
import showingFrom from './../../mixins/showingFrom'
import showingTo from './../../mixins/showingTo'

export default {
  name: 'Admins',
  mixins: [
    confirmDelete,
    filteredFields,
    getAdmin,
    onFiltered,
    showingFrom,
    showingTo
  ],
  data: () => {
    return {
      admin: {},
      organizations: [],
      organization_id: 0,
      currentPage: 1,
      fields: [
        {key: 'name'},
        {key: 'edit'},
        {key: 'delete'}
      ],
      filter: null,
      pageOptions: [ 5, 10, 15, 20, 25, 50 ],
      perPage: 5,
      totalRows: 0
    }
  },
  methods: {
    /**
     * Function that is evoked when delete modal box is opened.
     * @param {object} event - The event object that is fired.
     */
    deleteOrganizationOpen (event) {
      this.organization_id = event.params.id
    },
    /**
     * Uses delete method to soft delete an organization in the backend API.
     */
    deleteOrganization () {
      let self = this

      axios.delete(`${process.env.VUE_APP_API_URL}api/organizations/${this.organization_id}`, {
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          self.getOrganizations()

          self.$notify({
            group: 'foo-velocity',
            title: `Organization successfully deleted!`,
            text: `<br><br>`,
            type: 'success'
          })
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    /**
     * Gets the list of all organizations from the backend API and stores it in the organizations array data property.
     */
    getOrganizations () {
      let self = this

      axios.get(`${process.env.VUE_APP_API_URL}api/organizations`, {
        headers: {
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          self.organizations = self.getOrgData(response.data.data)
          self.totalRows = self.organizations.length
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    /**
     * Formats the list of organizations into a array of objects to be rendered in a bootstrap-vue table.
     * @param {array} data - The array of organizations.
     */
    getOrgData (data) {
      let newData = []

      for (let i = 0; i < data.length; i++) {
        newData.push({
          id: data[i].org_id,
          name: data[i].name
        })
      }

      return newData.reverse()
    }
  },
  mounted () {
    this.getAdmin()
    this.getOrganizations()
  }
}
</script>
